import React, { useState, useEffect } from "react";
import { message, Spin } from "antd";
import Layout from "../../components/Layout";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import GlassCard from "../../components/premium/GlassCard";
import CampaignForm from "./CampaignForm";
import { getCampaignById, updateCampaign } from "../../services/campaign/campaignServices";
import slugs from "../../resources/slugs";

const EditCampaign = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [campaignData, setCampaignData] = useState(null);

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const res = await getCampaignById(id);
        if (res?.success) {
          setCampaignData(res.data);
        } else {
          message.error(res?.message || "Failed to fetch campaign details");
          navigate(slugs.campaigns);
        }
      } catch (error) {
        message.error("An error occurred while fetching campaign details");
        navigate(slugs.campaigns);
      } finally {
        setFetching(false);
      }
    };

    if (id) fetchCampaign();
  }, [id, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await updateCampaign(id, values);
      if (res?.success) {
        message.success("Campaign updated successfully");
        navigate(slugs.campaigns);
      } else {
        message.error(res?.message || "Failed to update campaign");
      }
    } catch (error) {
      message.error("An error occurred while updating the campaign");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="edit-campaign-container">
        <div 
          style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <ArrowLeftOutlined />
          <h2 style={{ margin: 0 }}>Edit Campaign</h2>
        </div>

        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          {fetching ? (
            <div style={{ textAlign: "center", padding: "100px" }}>
              <Spin size="large" tip="Loading campaign details..." />
            </div>
          ) : (
            <GlassCard padding="40px">
              <p style={{ marginBottom: "32px", color: "var(--text-muted)" }}>
                Update the campaign details below. Some fields may be restricted if the campaign is already active.
              </p>
              <CampaignForm 
                initialValues={campaignData} 
                onFinish={onFinish} 
                loading={loading} 
                btnText="Update Campaign" 
              />
            </GlassCard>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default EditCampaign;
